import React from 'react';
import { BsArrowRight } from 'react-icons/bs'; // Using the icon from your preferred style

const TimelineItem = ({ title, day, weekday, hasEvent, isCurrentDay, onViewClick }) => {
  // --- Style Determination ---
  // These conditions are based on the style of the component you shared.
  const isHighlighted = hasEvent || isCurrentDay;

  // Main container background
  const containerBg = isCurrentDay 
    ? "bg-orange-500 dark:bg-orange-500" 
    : hasEvent 
    ? "bg-gray-100 dark:bg-navy-700" 
    : "bg-white dark:bg-navy-800";
  
  // Text color for title and icons
  const textColor = isCurrentDay 
    ? "text-white" 
    : "text-navy-700 dark:text-white";

  // Subdued text color for weekday/details
  const subTextColor = isCurrentDay 
    ? "text-orange-100"
    : "text-gray-600 dark:text-gray-400";
  
  // Background for the date block itself
  const dateBlockBg = isCurrentDay 
    ? "bg-white/20" 
    : "bg-gray-100 dark:bg-navy-600";

  return (
    <div className={`flex w-full items-center justify-between gap-4 rounded-xl p-2 transition-colors duration-200 ${containerBg}`}>
      {/* Left side: Date and Title */}
      <div className="flex items-center gap-4">
        <div className={`flex h-16 w-16 flex-col items-center justify-center rounded-lg ${dateBlockBg}`}>
          <p className={`text-xs font-bold uppercase ${subTextColor}`}>
            {weekday.substring(0, 3)}
          </p>
          <h5 className={`text-3xl font-bold ${textColor}`}>
            {day}
          </h5>
        </div>
        <div className="flex flex-col">
          <h5 className={`text-base font-bold leading-6 ${textColor}`}>
            {title}
          </h5>
          <p className={`text-sm font-medium ${subTextColor}`}>
            {weekday}
          </p>
        </div>
      </div>

      {/* Right side: "View Event" Button */}
      {hasEvent && (
        <button 
          onClick={onViewClick} 
          className="flex h-12 w-12 items-center justify-end pr-3"
          aria-label={`View details for ${title}`}
        >
          <BsArrowRight className={`text-2xl transition-colors ${subTextColor} group-hover:text-white`} />
        </button>
      )}
    </div>
  );
};

export default TimelineItem;
